import computeClassName from '../../../../../../utils/computeClassName';
import defaultToIfFalsy from '../../../../../../utils/defaultToIfFalsy';
// TODO: configure 'fill' and 'stroke' in tailwind.config.js
// Refer to: https://tailwindcss.com/docs/stroke#customizing
const propsDefaults = Object.freeze({
  className: '',
  fill1ClassName: 'fill-cc-gray-dark',
  fill2ClassName: 'stroke-cc-white'
});

export default function CCIconInfoSolid16x16(
  {
    className = propsDefaults.className,
    fill1ClassName = propsDefaults.fill1ClassName,
    fill2ClassName = propsDefaults.fill2ClassName
  }) {
  const computedClassName = computeClassName(className, '');
  const computedFill1ClassName = computeClassName(defaultToIfFalsy(fill1ClassName, propsDefaults.fill1ClassName), '');
  const computedFill2ClassName = computeClassName(defaultToIfFalsy(fill2ClassName, propsDefaults.fill2ClassName), '');
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={computedClassName}>
      <path d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" fill="#1B1C1D" className={computedFill1ClassName}/>
      <path d="M8 5C8.55228 5 9 4.55228 9 4C9 3.44772 8.55228 3 8 3C7.44772 3 7 3.44772 7 4C7 4.55228 7.44772 5 8 5Z" fill="white" className={computedFill2ClassName}/>
      <path d="M7 12C7 12.5523 7.44772 13 8 13C8.55228 13 9 12.5523 9 12V7.3C9 6.74772 8.55228 6.3 8 6.3C7.44772 6.3 7 6.74772 7 7.3L7 12Z" fill="white"/>
    </svg>
  );
}
